import { CircularProgress } from "@mui/material";
import { memo } from "react";
import CustomInput from "../../components/inputs/CustomInput";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { CenteredBox } from "../../components/layouts/OneViewBox";

const CreateUi = ({
  title,
  isUpdate,
  fields,
  setFields,
  loading,
  onSubmit,
}) => {
  return (
    <>
      <CustomDialog
        loading={loading}
        err={fields.err}
        onSubmit={onSubmit}
        title={`${isUpdate ? "Update" : "Create"} ${title}`}
        closeText="Close"
        confirmText={`${isUpdate ? "Update" : "Create"}`}
      >
        {loading ? (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        ) : (
          <>
            {
              <CustomInput
                autoFocus={true}
                disabled={loading}
                value={fields.channel_name}
                onChange={(e) =>
                  setFields({
                    ...fields,
                    err: "",
                    channel_name: e.target.value,
                  })
                }
                type="text"
                label={"Channel Name*"}
              />
            }
            {
              <CustomInput
                disabled={loading}
                value={fields.identifier}
                onChange={(e) =>
                  setFields({ ...fields, err: "", identifier: e.target.value })
                }
                type="text"
                label={"Identifier"}
              />
            }
            {
              <CustomInput
                disabled={loading}
                value={fields.priority}
                onChange={(e) =>
                  setFields({
                    ...fields,
                    err: "",
                    priority: e.target.value,
                  })
                }
                type="text"
                label={"Priority*"}
              />
            }
          </>
        )}
      </CustomDialog>
    </>
  );
};
export default memo(CreateUi);
